export const version = '2.7.1'
